class RatingLayer extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
    this.state = this.dataset.state;
    this.content = this.querySelector('[data-content]');
    this.closeButton = this.querySelectorAll('[data-close]');

    this.closeButton.forEach((closeButton) => closeButton.addEventListener('click', this.close.bind(this)));
  }

  async open(productUrl) {
    this.setState('loading');
    try {
      const response = await fetch(productUrl);
      const responseJson = await response.json();
      this.updateContent(responseJson);
      this.setState('loaded');
    } catch (error) {
      console.error(error);
      this.close();
    }
  }

  close() {
    this.setState('closed');
  }

  setState(newState) {
    this.dataset.state = newState;
  }

  updateContent(jsonResponse) {
    if (!jsonResponse.hasOwnProperty('product-rating')) return;
    this.content.innerHTML = jsonResponse['product-rating'];
  }
}
customElements.define('rating-layer', RatingLayer);

class RatingLayerOpener extends HTMLElement {
  constructor() {
    super();
    this.ratingLayer = document.querySelector('rating-layer');
    if (!this.ratingLayer) return;

    this.addEventListener('click', async () => {
      const url = this.dataset.url.includes('?')
        ? `${this.dataset.url}&sections=product-rating`
        : `${this.dataset.url}?sections=product-rating`;
      this.ratingLayer.open(url);
    });
  }
}
customElements.define('rating-layer-opener', RatingLayerOpener);
